var _path, _path2, _path3;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFailed72(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M69 36c0 18.225-14.775 33-33 33S3 54.225 3 36 17.775 3 36 3s33 14.775 33 33zm3 0c0 19.882-16.118 36-36 36S0 55.882 0 36 16.118 0 36 0s36 16.118 36 36z",
    fill: "#F22458"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.393 25.893a1.5 1.5 0 0 1 2.122 0l19.092 19.092a1.5 1.5 0 1 1-2.122 2.121L25.393 28.015a1.5 1.5 0 0 1 0-2.122z",
    fill: "#F22458"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.393 47.106a1.5 1.5 0 0 1 0-2.12l19.092-19.093a1.5 1.5 0 1 1 2.122 2.122L27.515 47.106a1.5 1.5 0 0 1-2.122 0z",
    fill: "#F22458"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailed72);
export default __webpack_public_path__ + "static/media/failed_72.1c6ce2e8.svg";
export { ForwardRef as ReactComponent };